import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://real.suraviantisuiciderod.com/api';

// Create axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Send cookies with every request
});

// Store access token in memory (not persistent)
let accessToken = null;

// Request interceptor - add access token to headers and handle FormData
axiosInstance.interceptors.request.use(
  (config) => {
    // Add authorization header if token exists
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    // Set Content-Type only for non-FormData requests
    // For FormData, let the browser set it automatically with boundary
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json';
    } else {
      // For FormData, remove Content-Type so browser sets it correctly
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle token refresh on 401
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If error is 401 and we haven't already tried to refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Try to refresh the token
        const response = await axios.post(`${API_URL}/auth/refresh`, {}, {
          withCredentials: true,
        });

        // Update the access token
        accessToken = response.data.accessToken;

        // Retry original request with new token
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // Refresh failed - clear auth and redirect to login
        accessToken = null;
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// Export function to set access token
export const setAccessToken = (token) => {
  accessToken = token;
};

// Export function to get access token
export const getAccessToken = () => accessToken;

// Export function to clear access token
export const clearAccessToken = () => {
  accessToken = null;
};

export default axiosInstance;
